import BaseError from "./BaseError";

export default class UnknownError extends BaseError {
  constructor(message: string, statusCode?: number | string, info?: any, cause?: Error) {
    super({
      statusCode: statusCode || 500,
      message,
      info: info || null,
      cause,
    });
    this.name = "UnknownError";
  }
}
